/*

Saikrishna 27/10/2022 3075234474 Scheduling functionality (Range of recurrence,
Reccurence Pattern- daily(bugs formik),weekly(bugs formik),monthly(newly added),yearly(newly added)) and save API integrated
Prakash 28/10/2022 3075234474 Scheduling UI Enhancements --> ,Added Styling Classes for UI enhancements -->
Saikrishna 10/28/2022 3075234474 Fixed minor bugs and added back and next appropriate buttons
akhila 10/29/2022 3075234474 integrated get api
Saikrishna 29/10/2022 3075234474 updated payload as per BE
Prakash 10/29/2022 3075234474 Added New UX Changes for Buttons.
Prakash Gummala 11/02/2022 3075234474 Fixed Responsiveness for 768px.
akhila 03/11/2022 3075234474 get api integration and data prepopulation
akhila 04/11/2022 3075234474 adding conditions in check boxs
akhila 09/11/2022 3075234474 Added validation
akhila  10/11/2022 3075234474 fixed save and next bug.
akhila  11/11/2022 3075234474 fixed validations issues
akhila 11/11/2022 3075234474 fixed week validations
Prakash  11/11/2022 3075234474 fixed validations Alignments issues.
akhila 11/12/2022 3075234474 fixed form reset and validation issues.
Ashraf 11/12/2022 3075234474 fixed redirecting issue.
Ashraf 11/14/2022 3075234474 rendering scheduler for night jobs
akhila 11/14/2022 3075234474 integrated night job get api
akhila 11/19/2022 3075234474 fixed payload issues and adding RunOnce field
akhila 11/19/2022 3075234474 fixed data prepopulation issues in nightJobsScheduler
SaiKrishna 11/23/2022 3225736869 Improper data and Faulty API calls regarding night jobs save api fixed.
akhila 11/11/2022 3075234474 added new UI Fields for Reports
Sohel 11/28/2022  3031450488 Added buttons
Sohel 11/28/2022  3031450488 Added run once button
Suresh Peddavoora 11/29/2022 3031450488 Fixed Button Spacing Alignments
Saikrishna 11/30/2022 2701350359  required changes dne for reports
Sai Maheshwar 11/30/2022 2701350359  Added run manually option in scheduler
akhila 12/06/2022 2701350359 added default no end date in night jobs
Ashraf 12/16/2022 2701350359 fixed role based access
Ashraf 12/20/2022 2701350359 fixed user role access
akhila 12/20/2022 2701350359 removed jobconfig save api call
akhila 12/22/2022 2701350359 fixed start Validation issue
sai Krishna 12/23/2022 3031450488 add Work Queue code, Reportcode,jobcode  and Work Queue description,Report description ,job description
akhila 12/23/2022 2701350359 fixed start issue
akhila 12/26/2022 2701350359 fixed startDate and endDate issue
lalitha 12/26/2022 2701350359 fixed prepopulating issue of report code and report description when clicked on edit.
akhila 12/26/2022 2701350359 removd week validation
Ashraf 12/28/2022 2701350359 renamed reoccurance label
dilip 12/28/2022 2701350359 Changed date format
Ashraf 01/04/2022 2701350359 fixed time picker issues.
kavyareddy 01/05/2023 2701350359 Fixed toast message issue
Akhila 02/01/2023 2701350359 bug fixed invalid validation issue fixed
Sohel 02/09/2023 3031450488 Added runManually in payload
Ravi 02/09/2023 2701350359 rename Reoccurance Pattern to Recurrence Pattern
Ravi 02/09/2023 2701350359 rename Reoccurance Pattern to Recurrence Pattern
Prakash 02/13/2023 2701350359 Added New UI Style-classes for buttons.
Akhila 02/14/2023 2701350359 Added validation and bug fixed of start date and start time
Sohel 02/15/2023 2701350359 Batch Triggers Schedular Changes
Sohel 02/16/2023 2701350359 Fixed Validation Issue
suresh peddavoora 02/22/2023 2701350359 New UI changes implemented
Ravi  03/02/2023 2701350359 Added validation start Date cannot past date
Akhila  03/02/2023 2701350359 Added validation start Date cannot past date in scheduler
Phaneendra 03/15/2023 2701350359 fixed default no end date radio button bug
Prakash 06/04/2023 2701350359 fixed alignments issue in responsive
Prakash 07/04/2023 2701350359 fixed radion button color
Sohel 05/31/2023 2701350359 Fixed Schedular StartDate Issue
Sohel 05/31/2023 2701350359 Fixed Schedular endByDate Issue
Sohel 06/15/2023 2701350359 Fixed Payload Issue
Sohel 06/16/2023 2701350359 Fixed Validation Issue
Sohel 10/17/2023 2701350359 Fixed Role Access Disabled Issue
Dilip-pds 11/03/2023  2701350359 Removed unecesarry comment code

*/

import {
  Button,
  Card,
  FormHelperText,
  Grid,
  Switch,
  TextField,
  Typography,
  withStyles,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import React, {useEffect} from 'react';
import 'rc-time-picker/assets/index.css';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  // TimePicker,
} from '@material-ui/pickers';
import reusableInputStyles from '../../../../../components/InputStyles';
import DailyForm from './DailyForm';
import DateFnsUtils from '@date-io/date-fns';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import WeeklySchedule from './WeeklySchedule';
import MonthlySchedule from './MonthlySchedule';
import YearlySchedule from './YearlySchedule';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import {
  postScheduleDetails,
  fetchSchedule,
  resetSchedule,
  fetchBasicInfo,
} from '../../../../../redux/reducers/ReportMaster';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {getDate} from '../../../../../util/dateHelper';
import * as Yup from 'yup';
import {
  ResetMessage as resetMessage,
  fetchJobDetails,
  fetchSchedules,
} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import PageLoader from './../../../../../components/PageLoader/index';
import {REPORTING_EXPORT} from '../../../../../constants/ReusableRoleAccess';
import BreadCrums from '../../../../../util/BreadCrum';
import TimePicker from 'rc-time-picker';
import {regExpOnlyNumber} from '../../../../../util/RegexPatterns';
import {onlyNumberAllow} from '../../../../../util/Content';
import {fetchTriggerGroup} from '../../../../../redux/reducers/TriggerGroup';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const MonthNameOptions = [
  {key: '1', value: 'January'},
  {key: '2', value: 'February'},
  {key: '3', value: 'March'},
  {key: '4', value: 'April'},
  {key: '5', value: 'May'},
  {key: '6', value: 'June'},
  {key: '7', value: 'July'},
  {key: '8', value: 'August'},
  {key: '9', value: 'September'},
  {key: '10', value: 'October'},
  {key: '11', value: 'November'},
  {key: '12', value: 'December'},
];
const WeekNoOptions = [
  {key: '1', value: 'First'},
  {key: '2', value: 'Second'},
  {key: '3', value: 'Third'},
  {key: '4', value: 'Fourth'},
];
const WeekDayNameOptions = [
  {key: 'MON', value: 'Monday'},
  {key: 'TUE', value: 'Tuesday'},
  {key: 'WED', value: 'Wednesday'},
  {key: 'THU', value: 'Thursday'},
  {key: 'FRI', value: 'Friday'},
  {key: 'SAT', value: 'Saturday'},
  {key: 'SUN', value: 'Sunday'},
];

const PurpleSwitch = withStyles({
  switchBase: {
    'color': '#056c93',
    '&$checked': {
      color: '#056c93',
    },
    '&$checked + $track': {
      backgroundColor: '#056c93',
    },
  },
  checked: {},
  track: {},
})(Switch);
const Scheduler = ({
  handleBack,
  setTabValue: setValue,
  nightJobsScheduler,
  setTabValue,
  handleDirty,
  workQueue,
  selected,
  editExisting,
  batchTriggers = false,
  rowSelected,
}) => {
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {roleData} = useSelector(({role}) => role);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const roleScAccess = roleData?.window?.['Scheduler']?.SC;
  const roleWQSAccess = roleData?.window?.['Work Queue Setup']?.WQS;
  const roleBTAccess = roleData?.window?.['Batch Triggers']?.BT;
  const {
    reportCode,
    reportName,
    successMsg,
    addScheduleStatus,
    ScheduleData,
    isLoader,
    basicInfoData,
  } = useSelector(({reportMaster}) => ({...reportMaster, isLoader: reportMaster.isLoading}));
  const {jobDetailsData, jobDataId, jobScheduleData, isLoading} =
    useSelector(({addNightJob}) => addNightJob);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const {
    // isLoading,
    // successMsg,
    // errorMsg,
    triggerGroupData,
    groupCode,
    batchTriggerId,
  } = useSelector(({addTriggerGroup}) => addTriggerGroup);

  const getObject = (option, options) => {
    console.log(options, 'options');
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.key === option) {
          label = item;
        }
      });
    return label;
  };

  const newArray = ScheduleData?.dayOfWeek?.split(',');
  const newArray1 = jobScheduleData?.dayOfWeek?.split(',');
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const validationSchema = Yup.object().shape({
    endByDate: Yup.date()
      .nullable(true)
      .transform((value) =>
        value === '' || value === null || value === undefined || isNaN(value) ? null : value,
      )
      .typeError('Invalid Date Format')
      .test('endByDate', 'End By is required', function(value, context) {
        const day = context?.parent;
        if (
          day?.endSchedule === 'endBy' &&
          (day?.endByDate === undefined || day?.endByDate === null)
        ) {
          return false;
        } else {
          return true;
        }
      })
      .test('endByDate', 'End date should be greater than Start date', function(date, context) {
        const day = context?.parent;
        console.log(day, 'day');
        console.log(day?.startDate, 'start effectiveDate');
        const effectiveDate = moment(day?.startDate).format('YYYY-MM-DD');
        console.log(effectiveDate, 'effectiveDate');
        const endDate = moment(date).format('YYYY-MM-DD');
        console.log(endDate, 'endDate  effectiveDate');
        if (day?.endSchedule === 'endBy' && endDate <= effectiveDate) {
          console.log('h');
          return false;
        } else {
          return true;
        }
      }),
    startDate: Yup.date()
      .nullable(true)
      .transform((value) =>
        value === '' || value === null || value === undefined || isNaN(value) ? null : value,
      )
      .test('startTime', 'Start Date is required', function(value, context) {
        const day = context?.parent;
        if ([null, undefined]?.includes(day?.startDate) && day?.runManually !== true) {
          return false;
        } else {
          return true;
        }
      })
      .min(today, 'Start Date cannot be a previous Date')
    // .test("startTime", "Start Date cannot be a previous Date", function (value) {
    //   const sDate = moment(value).format("YYYY-MM-DD");
    //   if (ScheduleData?.startDate >= sDate || jobScheduleData?.startDate >= sDate) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // })
      .typeError('Invalid Date Format'),

    startTime: Yup.date()
      .test('startTime', 'Start Time is required', function(value, context) {
        const day = context?.parent;
        if ([null, undefined]?.includes(day?.startTime) && day?.runManually !== true) {
          return false;
        } else {
          return true;
        }
      })
      .nullable()
      .typeError('Invalid Time Format'),
    occurrences: Yup.string()
      .test('occurrences', 'Occurrences is required', function(value, context) {
        const day = context?.parent;
        if (day?.endSchedule === 'endAfter' && day?.occurrences === undefined) {
          return false;
        } else {
          return true;
        }
      })
      .matches(regExpOnlyNumber, onlyNumberAllow),
    dailyNoOfDays: Yup.string()
      .test('dailyNoOfDays', 'Days are required', function(value, context) {
        const day = context?.parent;
        if (
          day?.daily === 'every' &&
          day?.reccurencePattern === 'daily' &&
          day?.dailyNoOfDays === undefined
        ) {
          return false;
        } else {
          return true;
        }
      })
      .matches(regExpOnlyNumber, onlyNumberAllow),
    weeks: Yup.string()
      .test('weeks', 'Atleast one day is required', function(value, context) {
        const day = context?.parent;
        if (
          !(day?.mon || day?.tue || day?.wed || day?.thu || day?.fri || day?.sat || day?.sun) &&
          day?.reccurencePattern === 'weekly'
        ) {
          return false;
        } else {
          return true;
        }
      })
      .matches(regExpOnlyNumber, onlyNumberAllow),
    monthlyDay: Yup.string()
      .nullable()
      .test('monthlyDay', 'Day is required', function(value, context) {
        const day = context?.parent;
        if (
          day?.monthly === 'day' &&
          day?.reccurencePattern === 'monthly' &&
          day?.monthlyDay === undefined
        ) {
          return false;
        } else {
          return true;
        }
      })
      .matches(regExpOnlyNumber, onlyNumberAllow),
    monthlyMonth: Yup.string()
      .nullable()
      .test('monthlyMonth', 'month is required', function(value, context) {
        const day = context?.parent;
        if (
          day?.monthly === 'day' &&
          day?.reccurencePattern === 'monthly' &&
          day?.monthlyMonth === undefined
        ) {
          return false;
        } else {
          return true;
        }
      })
      .matches(regExpOnlyNumber, onlyNumberAllow),
    monthlyFrequencyNo: Yup.object()
      .nullable()
      .test('monthlyFrequencyNo', 'Months Required', function(value, context) {
        const day = context?.parent;
        if (
          day?.monthly === 'weekDay' &&
          day?.reccurencePattern === 'monthly' &&
          day?.monthlyFrequencyNo === undefined
        ) {
          return false;
        } else {
          return true;
        }
      }),
    monthlyWeekNo: Yup.object()
      .nullable()
      .test('monthlyWeekNo', 'Monthly week No. Required', function(value, context) {
        const day = context?.parent;
        if (
          day?.monthly === 'weekDay' &&
          day?.reccurencePattern === 'monthly' &&
          (day?.monthlyWeekNo === null ||
            day?.monthlyWeekNo === undefined ||
            day?.monthlyWeekNo === '')
        ) {
          return false;
        } else {
          return true;
        }
      }),
    monthlyWeekDayName: Yup.object()
      .nullable()
      .test('monthlyWeekDayName', 'Monthly week Day Required', function(value, context) {
        const day = context?.parent;
        if (
          day?.monthly === 'weekDay' &&
          day?.reccurencePattern === 'monthly' &&
          (day?.monthlyWeekDayName === null ||
            day?.monthlyWeekDayName === undefined ||
            day?.monthlyWeekDayName === '')
        ) {
          return false;
        } else {
          return true;
        }
      }),
    yearlyYearFrequency: Yup.string()
      .test('dailyNoOfDays', 'Year\'s Required', function(value, context) {
        const day = context?.parent;
        if (day?.reccurencePattern === 'yearly' && day?.yearlyYearFrequency === undefined) {
          return false;
        } else {
          return true;
        }
      })
      .matches(regExpOnlyNumber, onlyNumberAllow),
    yearlyOnMonthName: Yup.object()
      .nullable()
      .test('yearlyOnMonthName', 'Month is Required', function(value, context) {
        const day = context?.parent;
        if (
          day?.yearly === 'yearlyOn' &&
          (day?.yearlyOnMonthName === null ||
            day?.yearlyOnMonthName === undefined ||
            day?.yearlyOnMonthName === '') &&
          day?.reccurencePattern === 'yearly'
        ) {
          return false;
        } else {
          return true;
        }
      }),
    yearlyOnDate: Yup.string()
      .test('yearlyOnDate', 'Date is required', function(value, context) {
        const day = context?.parent;
        if (
          day?.yearly === 'yearlyOn' &&
          day?.reccurencePattern === 'yearly' &&
          day?.yearlyOnDate === undefined
        ) {
          return false;
        } else {
          return true;
        }
      })
      .matches(regExpOnlyNumber, onlyNumberAllow),
    yearlyWeekNo: Yup.object()
      .nullable()
      .test('yearlyWeekNo', 'Yearly week no. is required', function(value, context) {
        const day = context?.parent;
        if (
          day?.yearly === 'yearlyOnThe' &&
          day?.reccurencePattern === 'yearly' &&
          (day?.yearlyWeekNo === null ||
            day?.yearlyWeekNo === undefined ||
            day?.yearlyWeekNo === '')
        ) {
          return false;
        } else {
          return true;
        }
      }),
    yearlyWeekDayName: Yup.object()
      .nullable()
      .test('yearlyWeekDayName', 'Yearly week day is required', function(value, context) {
        const day = context?.parent;
        if (
          day?.yearly === 'yearlyOnThe' &&
          day?.reccurencePattern === 'yearly' &&
          (day?.yearlyWeekDayName === null ||
            day?.yearlyWeekDayName === undefined ||
            day?.yearlyWeekDayName === '')
        ) {
          return false;
        } else {
          return true;
        }
      }),
    yearlyOnTheMonthName: Yup.object()
      .nullable()
      .test('yearlyOnTheMonthName', 'Month is required', function(value, context) {
        const day = context?.parent;
        console.log(day);
        if (
          day?.yearly === 'yearlyOnThe' &&
          day?.reccurencePattern === 'yearly' &&
          (day?.yearlyOnTheMonthName === null ||
            day?.yearlyOnTheMonthName === undefined ||
            day?.yearlyOnTheMonthName === '')
        ) {
          return false;
        } else {
          return true;
        }
      }),
  });

  const format = 'h:mm A';

  const initialValues = {
    runOnce: '',
    startTime: ScheduleData?.startTime ?
      moment(`${moment(new Date()).format('MM/DD/YYYY') + ' ' + ScheduleData?.startTime}`) :
      null,
    daily: ScheduleData && ScheduleData?.everyDay ? 'every' : 'everyWeekDay',
    weeklyWeekDays: [],
    weeks: '',
    monthly: ScheduleData?.lastDayOfMonth ?
      'lastDayOfMonth' :
      ScheduleData && ScheduleData?.index && ScheduleData?.dayName ?
        'weekDay' :
        'day',
    yearly: ScheduleData && ScheduleData?.dayDate ? 'yearlyOn' : 'yearlyOnThe',

    reccurencePattern: ScheduleData?.type ? ScheduleData?.type : 'daily',
    occurrences: ScheduleData?.occurrences ? ScheduleData?.occurrences : '',
    startDate: ScheduleData?.startDate ? getDate(ScheduleData?.startDate) : null,
    endByDate: ScheduleData?.endDate ? getDate(ScheduleData?.endDate) : null,
    endSchedule:
      ScheduleData && ScheduleData?.occurrences ?
        'endAfter' :
        ScheduleData && ScheduleData?.endDate ?
          'endBy' :
          ScheduleData && ScheduleData?.runOnce === 'Y' ?
            'runOnce' :
            ScheduleData?.type ?
              'noEndDate' :
              'noEndDate',

    dailyNoOfDays: ScheduleData?.everyDay ? ScheduleData?.everyDay : '',
    everyWeekDay: ScheduleData?.everyWeekday ? ScheduleData?.everyWeekday : '',

    weeklyWeekFrequency: ScheduleData?.everyWeek ? ScheduleData?.everyWeek : '',
    mon: ScheduleData?.dayOfWeek && newArray ? newArray.includes('MON') : false,
    tue: ScheduleData?.dayOfWeek && newArray ? newArray.includes('TUE') : false,
    wed: ScheduleData?.dayOfWeek && newArray ? newArray.includes('WED') : false,
    thu: ScheduleData?.dayOfWeek && newArray ? newArray.includes('THU') : false,
    fri: ScheduleData?.dayOfWeek && newArray ? newArray.includes('FRI') : false,
    sat: ScheduleData?.dayOfWeek && newArray ? newArray.includes('SAT') : false,
    sun: ScheduleData?.dayOfWeek && newArray ? newArray.includes('SUN') : false,

    monthlyDay: ScheduleData?.dayDate ? ScheduleData?.dayDate : '',
    monthlyMonth:
      ScheduleData?.index && ScheduleData?.dayName && ScheduleData?.everyMonth ?
        '' :
        ScheduleData?.everyMonth,
    monthlyWeekDayName: ScheduleData?.dayName ?
      getObject(ScheduleData?.dayName, WeekDayNameOptions) :
      '',
    monthlyWeekNo: ScheduleData?.index ? getObject(ScheduleData?.index, WeekNoOptions) : '',
    monthlyFrequencyNo:
      ScheduleData?.index && ScheduleData?.dayName && ScheduleData?.everyMonth ?
        ScheduleData?.everyMonth :
        '',

    yearlyOnDate: ScheduleData?.dayDate ? ScheduleData?.dayDate : '',
    yearlyYearFrequency: ScheduleData?.everyYear ? ScheduleData?.everyYear : '',
    yearlyOnMonthName:
      ScheduleData && ScheduleData?.dayDate && ScheduleData?.monthNumber ?
        getObject(ScheduleData?.monthNumber, MonthNameOptions) :
        '',
    yearlyWeekDayName: ScheduleData?.dayName ?
      getObject(ScheduleData?.dayName, WeekDayNameOptions) :
      '',
    yearlyOnTheMonthName:
      ScheduleData && ScheduleData?.dayDate && ScheduleData?.monthNumber ?
        '' :
        getObject(ScheduleData?.monthNumber, MonthNameOptions),
    yearlyWeekNo: ScheduleData?.index ? getObject(ScheduleData?.index, WeekNoOptions) : '',
    runManually: !ScheduleData?.startDate,
  };

  const vals = {
    runOnce: '',
    startTime: null,
    daily: 'everyWeekDay',
    weeklyWeekDays: [],
    weeks: '',
    monthly: 'day',
    yearly: 'yearlyOnThe',

    reccurencePattern: 'daily',
    occurrences: '',
    startDate: null,
    endByDate: null,
    endSchedule: 'noEndDate',

    dailyNoOfDays: '',
    everyWeekDay: '',

    weeklyWeekFrequency: '',
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false,

    monthlyDay: '',
    monthlyMonth: '',
    monthlyWeekDayName: '',
    monthlyWeekNo: '',
    monthlyFrequencyNo: '',

    yearlyOnDate: '',
    yearlyYearFrequency: '',
    yearlyOnMonthName: '',
    yearlyWeekDayName: '',
    yearlyOnTheMonthName: '',
    yearlyWeekNo: '',
    runManually: true,
  };

  const initialState = {
    runOnce: jobScheduleData?.runOnce ? jobScheduleData?.runOnce : '',
    startTime: jobScheduleData?.startTime ?
      moment(`${moment(new Date()).format('MM/DD/YYYY') + ' ' + jobScheduleData?.startTime}`) :
      null,
    daily: jobScheduleData && jobScheduleData?.everyDay ? 'every' : 'everyWeekDay',
    weeklyWeekDays: [],
    weeks: '',
    monthly: jobScheduleData?.lastDayOfMonth ?
      'lastDayOfMonth' :
      jobScheduleData && jobScheduleData?.index && jobScheduleData?.dayName ?
        'weekDay' :
        'day',
    yearly: jobScheduleData && jobScheduleData?.dayDate ? 'yearlyOn' : 'yearlyOnThe',

    reccurencePattern: jobScheduleData?.type ? jobScheduleData?.type : 'daily',
    occurrences: jobScheduleData?.occurrences ? jobScheduleData?.occurrences : '',
    startDate: jobScheduleData?.startDate ? getDate(jobScheduleData?.startDate) : null,
    endByDate: jobScheduleData?.endDate ? getDate(jobScheduleData?.endDate) : null,
    endSchedule:
      jobScheduleData && jobScheduleData?.occurrences ?
        'endAfter' :
        jobScheduleData && jobScheduleData?.endDate ?
          'endBy' :
          jobScheduleData && jobScheduleData?.runOnce === 'Y' ?
            'runOnce' :
            jobScheduleData?.type ?
              'noEndDate' :
              'noEndDate',

    dailyNoOfDays: jobScheduleData?.everyDay ? jobScheduleData?.everyDay : '',
    everyWeekDay: jobScheduleData?.everyWeekday ? jobScheduleData?.everyWeekday : '',

    weeklyWeekFrequency: jobScheduleData?.everyWeek ? jobScheduleData?.everyWeek : '',
    mon: jobScheduleData?.dayOfWeek && newArray1 ? newArray1.includes('MON') : false,
    tue: jobScheduleData?.dayOfWeek && newArray1 ? newArray1.includes('TUE') : false,
    wed: jobScheduleData?.dayOfWeek && newArray1 ? newArray1.includes('WED') : false,
    thu: jobScheduleData?.dayOfWeek && newArray1 ? newArray1.includes('THU') : false,
    fri: jobScheduleData?.dayOfWeek && newArray1 ? newArray1.includes('FRI') : false,
    sat: jobScheduleData?.dayOfWeek && newArray1 ? newArray1.includes('SAT') : false,
    sun: jobScheduleData?.dayOfWeek && newArray1 ? newArray1.includes('SUN') : false,

    monthlyDay: jobScheduleData?.dayDate ? jobScheduleData?.dayDate : '',
    monthlyMonth:
      jobScheduleData?.index && jobScheduleData?.dayName && jobScheduleData?.everyMonth ?
        '' :
        jobScheduleData?.everyMonth,
    monthlyWeekDayName: jobScheduleData?.dayName ?
      getObject(jobScheduleData?.dayName, WeekDayNameOptions) :
      '',
    monthlyWeekNo: jobScheduleData?.index ? getObject(jobScheduleData?.index, WeekNoOptions) : '',
    monthlyFrequencyNo:
      jobScheduleData?.index && jobScheduleData?.dayName && jobScheduleData?.everyMonth ?
        jobScheduleData?.everyMonth :
        '',

    yearlyOnDate: jobScheduleData?.dayDate ? jobScheduleData?.dayDate : '',
    yearlyYearFrequency: jobScheduleData?.everyYear ? jobScheduleData?.everyYear : '',
    yearlyOnMonthName:
      jobScheduleData && jobScheduleData?.dayDate && jobScheduleData?.monthNumber ?
        getObject(jobScheduleData?.monthNumber, MonthNameOptions) :
        '',
    yearlyWeekDayName: jobScheduleData?.dayName ?
      getObject(jobScheduleData?.dayName, WeekDayNameOptions) :
      '',
    yearlyOnTheMonthName:
      jobScheduleData && jobScheduleData?.dayDate && jobScheduleData?.monthNumber ?
        '' :
        getObject(jobScheduleData?.monthNumber, MonthNameOptions),
    yearlyWeekNo: jobScheduleData?.index ? getObject(jobScheduleData?.index, WeekNoOptions) : '',
  };

  useEffect(() => {
    if (addScheduleStatus === 200) {
      setTimeout(() => {
        dispatch(resetSchedule());
        setValue(0);
      }, 2000);
    }
    if (nightJobsScheduler && addScheduleStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
        setTabValue(0);
      }, 2000);
    }
  }, [addScheduleStatus]);

  useEffect(() => {
    if (successMsg) {
      setTimeout(() => {
        dispatch(resetSchedule());
      }, 2000);
    }
  }, [successMsg]);

  // if (nightJobsScheduler){
  //   useEffect(() => {
  //     if (addNightJob === 200) {
  //       setTimeout(() => {
  //         dispatch(ResetMessage());
  //         setTabValue(0);
  //       }, 2000);
  //     }
  //   }, [addNightJob]);
  // }

  useEffect(() => {
    const frameworkScheduleId =
      batchTriggers && batchTriggerId ? batchTriggerId : reportCode ? reportCode : 0;
    const tabType = batchTriggers ?
      'Batch Triggers' :
      nightJobsScheduler ?
        'Schedule' :
        workQueue ?
          'WQ' :
          'Report';

    if (nightJobsScheduler && jobDataId) {
      dispatch(fetchJobDetails(jobDataId));
      dispatch(fetchSchedules(jobDataId));
    } else if (reportName) {
      dispatch(fetchSchedule(reportName, batchTriggers, frameworkScheduleId, tabType));
    } else if (groupCode) {
      dispatch(fetchSchedule(groupCode, batchTriggers, frameworkScheduleId, tabType));
    }
  }, []);

  useEffect(() => {
    if (reportCode) {
      dispatch(fetchBasicInfo(reportCode));
    }
  }, [reportCode]);
  useEffect(() => {
    if (batchTriggerId) {
      dispatch(fetchTriggerGroup(batchTriggerId));
    }
  }, [batchTriggerId]);
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      dayDate:
        values.reccurencePattern === 'monthly' && values?.monthly === 'day' ?
          values?.monthlyDay :
          values.reccurencePattern === 'yearly' && values?.yearly === 'yearlyOn' ?
            values?.yearlyOnDate :
            '', // monthly day 1 and // yearly 2nd line 2nd field
      dayName:
        values.reccurencePattern === 'monthly' && values?.monthly === 'weekDay' ?
          values?.monthlyWeekDayName?.key :
          values.reccurencePattern === 'yearly' && values?.yearly === 'yearlyOnThe' ?
            values?.yearlyWeekDayName?.key :
            '', // monthly the 2 ("MON") and yearly onthe second field
      lastDayOfMonth:
        values.reccurencePattern === 'monthly' && values?.monthly === 'lastDayOfMonth' ? 'L' : '',
      lastStep: batchTriggers ? 3 : 4,
      dayOfWeek:
        values.reccurencePattern === 'weekly' ?
          [
            values?.mon ? 'MON' : '',
            values?.tue ? 'TUE' : '',
            values?.wed ? 'WED' : '',
            values?.thu ? 'THU' : '',
            values?.fri ? 'FRI' : '',
            values?.sat ? 'SAT' : '',
            values?.sun ? 'SUN' : '',
          ]
            .toString()
            .replace(/,/g, '')
            .split(/(?<=^(?:.{3})+)(?!$)/)
            .toString() :
          '', // weekly
      endDate:
        values?.endSchedule === 'endBy' ?
          moment(values?.endByDate).format('YYYY-MM-DD') :
          undefined,
      everyDay:
        values.reccurencePattern === 'daily' && values?.daily === 'every' ?
          values?.dailyNoOfDays :
          '',
      everyHour: '',
      everyMonth:
        values.reccurencePattern === 'monthly' && values?.monthly === 'day' ?
          values?.monthlyMonth :
          values.reccurencePattern === 'monthly' && values?.monthly === 'weekDay' ?
            values?.monthlyFrequencyNo :
            '', // monthly day 2  & monthly the 3
      everyWeek: values.reccurencePattern === 'weekly' ? String(values?.weeklyWeekFrequency) : '', // weekly
      everyWeekday:
        values.reccurencePattern === 'daily' && values?.daily === 'everyWeekDay' ? 'MON-FRI' : '',
      everyYear: values.reccurencePattern === 'yearly' ? values?.yearlyYearFrequency : '', // yearly above radios years
      index:
        values.reccurencePattern === 'monthly' && values?.monthly === 'weekDay' ?
          values?.monthlyWeekNo?.key :
          values.reccurencePattern === 'yearly' && values?.yearly === 'yearlyOnThe' ?
            values?.yearlyWeekNo?.key :
            '', // monthly the 1 (1-4) and yearly on the first field
      monthNumber:
        values.reccurencePattern === 'yearly' && values?.yearly === 'yearlyOn' ?
          values?.yearlyOnMonthName?.key :
          values.reccurencePattern === 'yearly' && values?.yearly === 'yearlyOnThe' ?
            values?.yearlyOnTheMonthName?.key :
            '', // yearly 2nd line 1st field should send month number and yearly onthe third field
      occurrences: values?.endSchedule === 'endAfter' ? values?.occurrences : '',
      // reportScheduleId: 0,
      startDate: values?.startDate ? moment(values?.startDate).format('YYYY-MM-DD') : undefined,
      startTime: values?.startTime ? moment(values?.startTime).format('LT') : '',
      runOnce: values?.endSchedule === 'runOnce' ? 'Y' : 'N',
      type: values.reccurencePattern,
      reportCode:
        batchTriggers && groupCode ?
          groupCode :
          !nightJobsScheduler && reportName ?
            reportName :
            '',
      scheduledTaskCode: '',
      frameworkScheduleId:
        batchTriggers && batchTriggerId ? batchTriggerId : reportCode ? reportCode : 0,
      jobCode: jobDetailsData?.jobCode ? jobDetailsData?.jobCode : '',
      isRunManually: values?.runManually ? 'Y' : 'N',
      tabType: batchTriggers ?
        'Batch Triggers' :
        nightJobsScheduler ?
          'Schedule' :
          workQueue ?
            'WQ' :
            'Report',
    };

    dispatch(postScheduleDetails(payload));
  };

  const renderFields = (val, props) => {
    switch (val) {
    case 'daily':
      return <DailyForm {...props} />;
    case 'weekly':
      return <WeeklySchedule {...props} />;
    case 'monthly':
      return <MonthlySchedule {...props} />;
    case 'yearly':
      return <YearlySchedule {...props} />;
    default:
      return null;
    }
  };
  const resetSpecificFields = (fields, setFieldValue, setFieldError) => {
    fields &&
      fields?.length > 0 &&
      fields?.map((field) => {
        setFieldValue(field, '');
        // setFieldTouched(field,"")
        setFieldError(field, '');
      });
  };
  const notDailyFields = [
    'weeklyWeekFrequency',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
    'monthlyFrequencyNo',
    'monthlyWeekDayName',
    'monthlyWeekNo',
    'monthlyDay',
    'monthlyMonth',
    'yearlyYearFrequency',
    'yearlyOnMonthName',
    'yearlyOnDate',
    'yearlyWeekNo',
    'yearlyWeekDayName',
    'yearlyOnTheMonthName',
  ];
  const notWeeklyFields = [
    'dailyNoOfDays',
    'everyWeekDay',
    'monthlyFrequencyNo',
    'monthlyWeekDayName',
    'monthlyWeekNo',
    'monthlyDay',
    'monthlyMonth',
    'yearlyYearFrequency',
    'yearlyOnMonthName',
    'yearlyOnDate',
    'yearlyWeekNo',
    'yearlyWeekDayName',
    'yearlyOnTheMonthName',
  ];
  const notMonthlyFields = [
    'dailyNoOfDays',
    'everyWeekDay',
    'weeklyWeekFrequency',
    'mon',
    'tue',
    'wed',
    'thu',
    'fri',
    'sat',
    'sun',
    'yearlyYearFrequency',
    'yearlyOnMonthName',
    'yearlyOnDate',
    'yearlyWeekNo',
    'yearlyWeekDayName',
    'yearlyOnTheMonthName',
  ];

  return (
    <div>
      <Formik
        initialValues={nightJobsScheduler ? initialState : initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleChange,
            touched,
            setValues,
            errors,
            resetForm,
            handleBlur,
            setErrors,
            setFieldError,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          const disabledAllFields = values.runManually;
          return (
            <>
              {nightJobsScheduler ? (
                <div className="mb-4">
                  <BreadCrums
                    name={'Job Name'}
                    code={jobDetailsData?.jobCode}
                    description={'Job Description'}
                    descriptionValue={jobDetailsData?.jobDescription}
                  />
                </div>
              ) : workQueue ? (
                <BreadCrums
                  name={'Work Queue Name'}
                  code={basicInfoData?.reportCode}
                  description={'Work Queue Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              ) : batchTriggers ? (
                <BreadCrums
                  name={'Batch Trigger Name'}
                  code={triggerGroupData?.groupCode}
                  description={'Batch Trigger Description'}
                  descriptionValue={triggerGroupData?.groupDescription}
                />
              ) : (
                <BreadCrums
                  name={'Report Name'}
                  code={basicInfoData?.reportCode}
                  description={'Report Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              )}
              <Form>
                {console.log(values, 'val')}
                <div className={classes.globalFieldTextfields}>
                  <div>
                    {nightJobsScheduler ? null : (
                      <div className="d-flex justify-content-end">
                        <FormControlLabel
                          control={
                            <PurpleSwitch
                              checked={values.runManually}
                              onChange={(e) => {
                                setValues({...vals});
                                handleChange(e);
                              }}
                              name="runManually"
                            />
                          }
                          label="Run Manually"
                        />
                      </div>
                    )}
                    <Card className={`col-12 ${classes.cardWrapper} ${classes.checkBox}`}>
                      <Typography className={classes.labelLegend}>Frequency</Typography>
                      <div className="form-row mt-3 new-standard-textfields">
                        <div className="col-md-6 col-lg-4 form-group">
                          <div className="col  form-group">
                            <div className={classes.fieldLabel}>
                              <Typography className={classes.formLabel}>Start Date :</Typography>
                              <div className="scheduler-picker">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <Grid container>
                                    <KeyboardDatePicker
                                      format="MM/dd/yyyy"
                                      placeholder="MM/DD/YYYY"
                                      fullWidth
                                      disabled={disabledAllFields}
                                      value={values.startDate}
                                      name="startDate"
                                      minDate={new Date()}
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      helperText={null}
                                      onBlur={handleBlur}
                                      inputVariant="outlined"
                                      // label="Start Date"
                                      onChange={(val) => {
                                        // setTouched({ ...touched, endDate: true });
                                        setFieldValue('startDate', val);
                                        return {value: val};
                                      }}
                                      autoOk
                                      margin="dense"
                                      touched={touched?.startDate}
                                      error={Boolean(touched?.startDate && errors?.startDate)}
                                    />
                                  </Grid>
                                </MuiPickersUtilsProvider>
                                <FormHelperText
                                  style={{color: 'red'}}
                                  margin="dense"
                                  variant="outlined"
                                  position="relative"
                                >
                                  {touched?.startDate && errors && errors?.startDate}
                                </FormHelperText>
                              </div>
                            </div>
                          </div>
                          <div className="col  form-group">
                            <div className={classes.fieldLabel}>
                              <Typography className={classes.formLabel}>Start Time :</Typography>
                              <div className="scheduler-picker">
                                <TimePicker
                                  className="time-picker"
                                  showSecond={false}
                                  defaultValue={values?.startTime}
                                  value={values?.startTime}
                                  onChange={(val) => {
                                    setFieldValue('startTime', val);
                                  }}
                                  placeholder="HH:MM AM"
                                  touched={touched?.startTime}
                                  name="startTime"
                                  format={format}
                                  disabled={disabledAllFields}
                                  autoComplete={'off'}
                                  use12Hours
                                  // inputReadOnly
                                />
                                <FormHelperText
                                  style={{color: 'red', paddingTop: '5px'}}
                                  margin="dense"
                                  variant="outlined"
                                  position="relative"
                                >
                                  {touched?.startTime && errors && errors?.startTime}
                                </FormHelperText>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 ml-lg-4 new-standard-textfields">
                          <FormControl component="fieldset" className={classes.checkBox}>
                            <RadioGroup
                              aria-label="endSchedule"
                              name="endSchedule"
                              value={values.endSchedule}
                              onChange={handleChange}
                            >
                              <div>
                                <FormControlLabel
                                  value="noEndDate"
                                  control={<Radio />}
                                  label="No End Date"
                                  disabled={disabledAllFields}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('endByDate', null);
                                    setFieldValue('occurrences', '');
                                  }}
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  value="endAfter"
                                  control={<Radio />}
                                  label="End After: "
                                  disabled={disabledAllFields}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('endByDate', null);
                                  }}
                                />
                                <TextField
                                  margin="dense"
                                  variant="outlined"
                                  placeholder={``}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  className={classes.textComponent}
                                  disabled={values.endSchedule !== 'endAfter' || disabledAllFields}
                                  name="occurrences"
                                  value={values?.occurrences}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  error={Boolean(touched?.occurrences && errors?.occurrences)}
                                  onBlur={handleBlur}
                                />
                                <FormLabel className={`ml-2 ${classes.formLabel}`}>
                                  occurrences
                                </FormLabel>
                                <FormHelperText
                                  style={{color: 'red'}}
                                  margin="dense"
                                  variant="outlined"
                                  position="relative"
                                >
                                  {touched?.occurrences && errors && errors?.occurrences}
                                </FormHelperText>
                              </div>
                              <div className="d-flex align-items-center">
                                <FormControlLabel
                                  value="endBy"
                                  control={<Radio />}
                                  label="End By: "
                                  disabled={disabledAllFields}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('occurrences', '');
                                  }}
                                />
                                <div className="mt-3 form-group px-2">
                                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container>
                                      <KeyboardDatePicker
                                        className={classes.dateField}
                                        format="MM/dd/yyyy"
                                        placeholder="MM/DD/YYYY"
                                        value={values.endByDate}
                                        name="endByDate"
                                        disabled={values.endSchedule !== 'endBy'}
                                        minDate={new Date()}
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        helperText={null}
                                        onBlur={handleBlur}
                                        inputVariant="standard"
                                        // label="End By Date"
                                        onChange={(val) => {
                                          // setTouched({ ...touched, endDate: true });
                                          setFieldValue('endByDate', val);
                                        }}
                                        autoOk
                                        margin="dense"
                                        touched={touched?.endByDate}
                                        error={Boolean(touched?.endByDate && errors?.endByDate)}
                                      />
                                    </Grid>
                                  </MuiPickersUtilsProvider>
                                  <FormHelperText
                                    style={{color: 'red'}}
                                    margin="dense"
                                    variant="outlined"
                                  >
                                    {touched?.endByDate && errors && errors?.endByDate}
                                  </FormHelperText>
                                </div>
                              </div>
                              <div>
                                <FormControlLabel
                                  value="runOnce"
                                  control={<Radio />}
                                  label="Run Once"
                                  disabled={disabledAllFields}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setFieldValue('endByDate', null);
                                    setFieldValue('occurrences', '');
                                  }}
                                />
                              </div>
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </Card>
                    <Card className={`col-12 mt-3 ${classes.cardWrapper}`}>
                      <Typography className={classes.labelLegend}>Recurrence Pattern</Typography>
                      <div className="d-flex new-standard-textfields">
                        <div className="col-2">
                          <FormControl component="fieldset" className={classes.checkBox}>
                            <RadioGroup
                              aria-label="reoccurance pattern"
                              name="reccurencePattern"
                              value={values.reccurencePattern}
                              onChange={(e) => {
                                // resetForm();
                                handleChange(e);
                                setFieldValue('reccurencePattern', e.target.value);
                              }}
                            >
                              <FormControlLabel
                                value="daily"
                                control={<Radio />}
                                label="Daily"
                                disabled={disabledAllFields}
                                onChange={() => {
                                  resetSpecificFields(notDailyFields, setFieldValue, setFieldError);
                                }}
                              />
                              <FormControlLabel
                                value="weekly"
                                control={<Radio />}
                                disabled={disabledAllFields}
                                label="Weekly"
                                onChange={() => {
                                  resetSpecificFields(
                                    notWeeklyFields,
                                    setFieldValue,
                                    setFieldError,
                                  );
                                }}
                              />
                              <FormControlLabel
                                value="monthly"
                                control={<Radio />}
                                disabled={disabledAllFields}
                                label="Monthly"
                                onChange={() => {
                                  resetSpecificFields(
                                    notMonthlyFields,
                                    setFieldValue,
                                    setFieldError,
                                  );
                                }}
                              />
                              <FormControlLabel
                                value="yearly"
                                control={<Radio />}
                                disabled={disabledAllFields}
                                label="Yearly"
                                onChange={() => {
                                  resetSpecificFields(
                                    notMonthlyFields,
                                    setFieldValue,
                                    setFieldError,
                                  );
                                }}
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                        {values.reccurencePattern ? (
                          <div className="col-9 col-md-10" style={{borderLeft: '1px solid grey'}}>
                            {renderFields(values.reccurencePattern, {
                              values,
                              setFieldValue,
                              handleChange,
                              touched,
                              errors,
                              handleBlur,
                              MonthNameOptions,
                              WeekNoOptions,
                              WeekDayNameOptions,
                              setErrors,
                              resetForm,
                            })}
                          </div>
                        ) : null}
                      </div>
                    </Card>
                  </div>
                </div>
                <div className="new-standard-textfields d-flex justify-content-center my-2">
                  <Button
                    variant="outlined"
                    onClick={handleBack}
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  <Button
                    variant="outlined"
                    type={'submit'}
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    disabled={
                      (!roleScAccess?.edit && nightJobsScheduler && selected) ||
                      (!reportRoleAccess?.edit &&
                        editExisting &&
                        !nightJobsScheduler &&
                        !workQueue) ||
                      (workQueue && editExisting && !roleWQSAccess?.edit) ||
                      enabledSubmission || (batchTriggers && rowSelected && !roleBTAccess?.edit)
                    }
                    // onClick={() => {
                    //   if (disabledAllFields) {
                    //     resetForm();
                    //     setTabValue(0);
                    //   }
                    // }}
                  >
                    {disabledAllFields && !batchTriggers ? 'Save' : 'Schedule'}
                  </Button>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {!nightJobsScheduler && isLoader && <PageLoader />}
      {!nightJobsScheduler && successMsg && (
        <SuccessSnackbar
          successMsg={workQueue ? 'Work Queue Schedule added/modified successfully' : successMsg}
        />
      )}
      {nightJobsScheduler && successMsg && (
        <SuccessSnackbar successMsg={'Job added/modified successfully '} />
      )}
      {batchTriggers && successMsg && (
        <SuccessSnackbar successMsg={'Batch Triggers added/modified successfully'} />
      )}
    </div>
  );
};

export default Scheduler;
